// extracted by mini-css-extract-plugin
module.exports = {"contentEditable":"index_contentEditable__3-MYQ"};